import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'cc-channels-the-best',
  templateUrl: './channels-the-best.component.html',
  styleUrls: ['./channels-the-best.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ChannelsTheBestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
